var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.44472 0.85089L3.99965 4.43734L0.554579 0.85089C0.493027 0.786682 0.410398 0.750736 0.324356 0.750736C0.238314 0.750736 0.155686 0.786682 0.0941338 0.85089C0.0643304 0.882075 0.0406534 0.919299 0.0244895 0.960379C0.0083257 1.00146 0 1.04557 0 1.09013C0 1.13469 0.0083257 1.17881 0.0244895 1.21989C0.0406534 1.26097 0.0643304 1.29819 0.0941338 1.32938L3.75909 5.1455C3.82345 5.2125 3.90977 5.25 3.99965 5.25C4.08953 5.25 4.17585 5.2125 4.24021 5.1455L7.90516 1.33011C7.93517 1.2989 7.95903 1.26159 7.97532 1.22037C7.99161 1.17916 8 1.13487 8 1.09013C8 1.0454 7.99161 1.00111 7.97532 0.959894C7.95903 0.918677 7.93517 0.881362 7.90516 0.850153C7.84361 0.785946 7.76098 0.75 7.67494 0.75C7.5889 0.75 7.50627 0.785946 7.44472 0.850153V0.85089Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.6c0e16d6e94c6fae9d47202884a3a43b.svg";
export { ForwardRef as ReactComponent };